/**
 * Utility functions for managing user preferences
 */
import * as Sentry from "@sentry/react";

/**
 * Minimal interface for UserData object from useSudowriteStore
 * Based on client/src/models/UserData.js
 */
interface UserData {
  update: (data: Record<string, unknown>) => Promise<void>;
}

/**
 * Mark that user has manually changed their write model default
 */
export async function markWriteDefaultChanged(userData: UserData | null | undefined, writeModel?: string): Promise<void> {
  if (!userData) return;

  try {
    // UserData snapshots immediately hydrate editorOptions. Save the mode in
    // the same update as the preference flag so that snapshot cannot restore
    // the old mode while editorOptions' debounced save is still pending.
    await userData.update({ hasChangedWriteDefault: true, ...(writeModel && { writeModel }) });
  } catch (err) {
    const error = err as Error;
    Sentry.captureMessage('Failed to set hasChangedWriteDefault', {
      level: 'error',
      tags: { feature: 'write-model-selection' },
      extra: { error: error.message },
    });
  }
}
